import React from "react";
import { Typography, Box } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxSwitch from "components/UI/AcxSwitch";
import ControlsContainer from "./ControlsContainer";
import ServiceHierarchySelect from "../OrganizationModules/fields/ServiceHierarchySelect";

interface VoicemailControlsProps {
    selectedHierarchiesIds: string[];
    setSelectedHierarchiesIds: (ids: string[]) => void;
    isEnabled: boolean;
    setIsEnabled: (enabled: boolean) => void;
    orgId?: string;
    runOnAll: boolean;
    setRunOnAll: (runOnAll: boolean) => void;
    isViewOnly: boolean;
}

const VoicemailControls: React.FC<VoicemailControlsProps> = ({
    selectedHierarchiesIds,
    setSelectedHierarchiesIds,
    isEnabled,
    setIsEnabled,
    orgId,
    runOnAll,
    setRunOnAll,
    isViewOnly,
}) => {
    const heading = "Voicemail";
    const description = `Detects interactions that are solely
                        voicemail responses, and filters these
                        conversations out.`;

    return (
        <ControlsContainer
            heading={heading}
            description={description}
            isEnabled={isEnabled}
            setIsEnabled={setIsEnabled}
            maxHeight={300}
            isViewOnly={isViewOnly}
        >
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <AcxSwitch
                    id="voicemail-run-on-all"
                    checked={runOnAll}
                    onChange={(event) => {
                        setRunOnAll(event.target.checked);
                    }}
                    disabled={isViewOnly}
                />
                <Typography
                    component={"label"}
                    htmlFor="voicemail-run-on-all"
                    sx={{ cursor: "pointer" }}
                >
                    Run Voicemail model on all conversations
                </Typography>
            </Box>
            {!runOnAll && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Typography sx={{ color: theme.palette.gray[400] }}>
                        - or -
                    </Typography>
                    <ServiceHierarchySelect
                        orgId={orgId || ""}
                        value={selectedHierarchiesIds}
                        onChange={setSelectedHierarchiesIds}
                        fullWidth
                        placeholder="Select Hierarchies to run Voicemail model on"
                        label="Exclude Voicemail from these hierarchies:"
                        maxContainerHeight="200px"
                        isDisabled={isViewOnly}
                    />
                </Box>
            )}
        </ControlsContainer>
    );
};

export default VoicemailControls;
